module.exports = __webpack_public_path__ + "ni.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ni.svg
// module id = 731
// module chunks = 0